import { createTheme } from '@mui/material/styles';
import { arSD, enUS, zhCN } from '@mui/x-data-grid/locales';
import { getLanguageConfig, LANGUAGES, SITE_DIRECTIONS } from './constants/appConstants';

const DATA_GRID_LOCALES = { enUS, arSD, zhCN };

const getDataGridLocaleText = (language) =>
  DATA_GRID_LOCALES[getLanguageConfig(language).grid].components.MuiDataGrid.defaultProps.localeText;

const createAppTheme = (direction = SITE_DIRECTIONS.LTR, language = LANGUAGES.EN) =>
  createTheme({
    direction,
    typography: {
      fontFamily: '"Roboto", "PingFang SC", "Microsoft YaHei", "Noto Sans SC", sans-serif',
    },
    colorSchemes: { light: true, dark: false },
    palette: {
      primary: {
        dark: '#3741af',
        main: '#4f5efa',
        light: '#727efb',
      },
      secondary: {
        dark: '#b29420',
        main: '#ffd42f',
        light: '#ffdc58',
      },
    },
    components: {
      MuiMenu: {
        defaultProps: {
          disableScrollLock: true,
        },
      },
      MuiSelect: {
        defaultProps: {
          MenuProps: {
            disableScrollLock: true,
          },
        },
      },
      MuiTextField: {
        defaultProps: {
          size: 'small',
        },
      },
      MuiInputBase: {
        styleOverrides: {
          input: {
            direction: 'ltr',
            textAlign: 'left',
            unicodeBidi: 'plaintext',
          },
          inputMultiline: {
            direction: 'ltr',
            textAlign: 'left',
            unicodeBidi: 'plaintext',
          },
        },
      },
      MuiDrawer: {
        styleOverrides: {
          root: {
            boxShadow: '0px 0px 30px 0px rgba(0,0,0,0.1)',
          },
        },
      },
      MuiDataGrid: {
        defaultProps: {
          localeText: getDataGridLocaleText(language),
        },
        styleOverrides: {
          cell: {
            '&:focus': {
              outline: 'none',
            },
          },
        },
      },
    },
    shape: {
      borderRadius: 6, // Set global border radius value
    },
  });

export default createAppTheme;
